import { Theme } from "@/hooks/interface";

export const headerTheme: Record<Theme.ThemeType, { [key: string]: string }> = {
  light: {
    "--el-header-logo-text-color": "#303133",
    "--el-header-bg-color": "#E9ECEF",
    "--el-header-text-color": "#303133",
    "--el-header-text-color-regular": "#343A40",
    "--el-header-border-color": "#e4e7ed",
    "--el-header-avatar-color": "#fff"
  },
  inverted: {
    "--el-header-logo-text-color": "#dadada",
    "--el-header-bg-color": "#191a20",
    "--el-header-text-color": "#e5eaf3",
    "--el-header-text-color-regular": "#cfd3dc",
    "--el-header-border-color": "#414243",
    "--el-header-avatar-color": "#495057"
  },
  dark: {
    "--el-header-logo-text-color": "#dadada",
    "--el-header-bg-color": "rgb(18,18,18)",
    "--el-header-text-color": "#e5eaf3",
    "--el-header-avatar-color": "#495057",
    "--el-header-text-color-regular": "#cfd3dc",
    "--el-header-border-color": "#414243"
  }
};
